(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("Components/PopoverMenu", [], factory);
	else if(typeof exports === 'object')
		exports["Components/PopoverMenu"] = factory();
	else
		root["NextcloudVue"] = root["NextcloudVue"] || {}, root["NextcloudVue"]["Components/PopoverMenu"] = factory();
})(window, function() {
return 